const Confluent = () => (
  <img alt="Confluent logo" src="/img/customer-logos/confluent-logo-white.svg" />
);

export default Confluent;
